import React from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { useLanguage } from '../../i18n/LanguageContext';
import { NodeCardShell } from './NodeCardShell';
import { NodeCardProps } from './NodeCardProps';

export const BoilerNodeCard: React.FC<NodeCardProps> = ({
  node, index, onToggle, onCommand, onSettingsChange, onEditOpen,
}) => {
  const { t } = useLanguage();
  const s = node.settings ?? {};
  const temp = s.temperature ?? 55;

  const handleOn  = () => { if (node.state !== true)  onToggle(); };
  const handleOff = () => { if (node.state !== false) onToggle(); };

  const changeTemp = (delta: number) => {
    const next = Math.min(80, Math.max(30, temp + delta));
    onSettingsChange({ ...s, temperature: next });
    onCommand('setTemperature', { value: String(next) });
  };

  return (
    <NodeCardShell node={node} index={index} onEditOpen={onEditOpen}>
      <Box display="flex" gap={1} mb={1.5}>
        <Button
          variant={node.state !== true ? 'contained' : 'outlined'}
          color={node.state === false ? 'error' : 'inherit'}
          size="small" onClick={handleOff} disabled={node.isLoading} sx={{ flex: 1 }}
        >
          {t.statusOff}
        </Button>
        <Button
          variant={node.state === true ? 'contained' : 'outlined'}
          color={node.state === true ? 'success' : 'inherit'}
          size="small" onClick={handleOn} disabled={node.isLoading} sx={{ flex: 1 }}
        >
          {t.statusOn}
        </Button>
      </Box>

      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="caption" color="text.secondary" sx={{ minWidth: 56 }}>
          {t.boilerTargetTemp}
        </Typography>
        <IconButton size="small" aria-label={t.a11yDecrease(t.boilerTargetTemp)} onClick={() => changeTemp(-1)} disabled={temp <= 30 || node.isLoading}>
          <Remove fontSize="small" />
        </IconButton>
        <Typography variant="body1" sx={{ minWidth: 52, textAlign: 'center' }}>
          {temp}°C
        </Typography>
        <IconButton size="small" aria-label={t.a11yIncrease(t.boilerTargetTemp)} onClick={() => changeTemp(1)} disabled={temp >= 80 || node.isLoading}>
          <Add fontSize="small" />
        </IconButton>
      </Box>
    </NodeCardShell>
  );
};
